import {
  MOTORCYCLE_DETAILS_STEP,
  MOTORCYCLE_INTRO_STEP,
  MOTORCYCLE_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle";
import {
  MotorcycleProductDetailsFormValues,
  MotorcycleProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/motorcycleInterface";

import { Relation } from "Store/interfaces/Owner";
import { Trafikkforsikringsavgift } from "Store/interfaces/Trafikkforsikringsavgift";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { UsabilityCode } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Motorcycle";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { getDateStringFromAge } from "Utils/dateUtils";
import { formBooleanToBoolean } from "Utils/formUtils";

export interface MotorcycleProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;

  modelYear: number;
  brand: string;
  model: string;
  bonusLevelCode: string;

  insuranceHolderIsOwner: boolean;
  owner: {
    dateOfBirth?: string;
    relation?: Relation;
  };

  damageCountRecentYears: number;
  yearOfLastDamage?: number;

  usabilityCode: UsabilityCode;
  mortgagee: boolean;
  mcLocker: boolean;
  hasGarageForMotorcycle: boolean;

  trafikkforsikringsavgift?: Trafikkforsikringsavgift;
}

export const mapToCommerceMotorcycle = (
  data: Record<string, any>,
): MotorcycleProductBackend => {
  const motorcycleIntroData = data.formData[MOTORCYCLE_INTRO_STEP.id];
  const motorcycleDetailsData: MotorcycleProductDetailsFormValues =
    data.formData[MOTORCYCLE_DETAILS_STEP.id];
  const motorcyclePriceData: MotorcycleProductPriceFormValues =
    data.formData[MOTORCYCLE_PRICE_STEP.id];

  const insuranceHolderIsOwner = formBooleanToBoolean(
    motorcycleDetailsData.insuranceHolderIsOwner,
  );
  const relation = motorcycleDetailsData.relation;

  const user = data.customerData.newCustomerResponse;
  const otherOwnerAge = motorcycleDetailsData.age;
  const dateOfBirth = !insuranceHolderIsOwner
    ? getDateStringFromAge(otherOwnerAge as number)
    : user.dateOfBirth;

  return {
    name: INSURANCE_NAME_VALUE.MOTORCYCLE,
    coverageGroup: data.coverage,

    modelYear: Number(motorcycleIntroData.year),
    brand: motorcycleIntroData.brand,
    model: motorcycleIntroData.model,
    bonusLevelCode: motorcycleIntroData.bonus,

    insuranceHolderIsOwner,
    owner: {
      ...(relation ? { relation } : {}),
      dateOfBirth,
    },

    usabilityCode: motorcycleDetailsData.usabilityCode,
    mortgagee: formBooleanToBoolean(motorcycleDetailsData.mortgagee),
    mcLocker: formBooleanToBoolean(motorcycleDetailsData.mcLocker),
    hasGarageForMotorcycle: formBooleanToBoolean(motorcycleDetailsData.garage),

    ...mapFormToInjuries(
      motorcycleDetailsData.injuries,
      motorcycleDetailsData.injuryYear,
    ),

    trafikkforsikringsavgift: {
      monthlyAmount: motorcyclePriceData.tfaAmount.monthly,
      yearlyAmount: motorcyclePriceData.tfaAmount.yearly,
    },
  };
};
